import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Categories from "./components/Categories";
import NewReleases from "./components/NewReleases";
import Ranking from "./components/Ranking";
import Secret from "./components/Secret";
import Faq from "./components/Faq";

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "牛奶动漫库",
      url: "https://comicsrq.github.io/",
      description:
        "牛奶动漫库提供按年份、评分、标签筛选番剧的高级检索，支持OVA与剧场版分区，高口碑榜单与隐藏目录入口，快速定位你想看的动漫。",
      inLanguage: "zh-CN",
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "牛奶动漫库如何按年份检索番剧？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "在「番剧检索」页面选择目标年份即可，也可以结合评分排序与标签筛选组合使用，快速回看任意年份的口碑番剧。",
          },
        },
        {
          "@type": "Question",
          name: "剧场版和 OVA 分区有什么不同？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "剧场版指在影院上映的电影作品，OVA 则通常为发售的原创或番外动画。两者都在检索页按播放形式单独划分，方便直接定位。",
          },
        },
        {
          "@type": "Question",
          name: "评分是怎么来的？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "评分综合观众口碑与多平台评价沉淀而成，并用于高口碑榜单排序。评分越高，说明越经得起多数观众的认可。",
          },
        },
        {
          "@type": "Question",
          name: "能只看某个标签下的番吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "可以。分类导航与检索页都支持按热血、恋爱、奇幻、悬疑等 18 个标签单独筛选，也能多标签叠加检索。",
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <Categories />
        <NewReleases />
        <Ranking />
        <Secret />
        <Faq />
      </main>
      <Footer />
    </>
  );
}